define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 高程模式。
     *
     * @exports EnumAltitudeMode
     * 
     * @see PolylineSymbol#altitudeMode
     * @see PolygonSymbol#altitudeMode
     */
    var EnumAltitudeMode = {
        /**
         * 绝对高程。
         * @type {String}
         * @constant
         */
        ABSOLUTE: "ABSOLUTE_ALTITUDE",

        /**
         * 相对高程。
         * @type {String}
         * @constant
         */
        RELATIVE: "RELATIVE_TO_ALTITUDE",

        /**
         * 紧贴场景。
         * @type {String}
         * @constant
         */
        CLAMP: "CLAMP_TO_SCENE"
    }
    freezeObject(EnumAltitudeMode)

    /**
     * 反向查找贴地模式的名称。
     * 
     * @param {Number} value 贴地模式的数值。
     * @returns {String} 贴地模式的名称。
     */
    function getName(value) {
        for (var key in EnumAltitudeMode) {
            if (EnumAltitudeMode.hasOwnProperty(key) && EnumAltitudeMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        ABSOLUTE: "ABSOLUTE_ALTITUDE",
        RELATIVE: "RELATIVE_TO_ALTITUDE",
        CLAMP: "CLAMP_TO_SCENE",
        getName: getName
    }
})